import axiosIns from '@/libs/axios'
import {getUserData} from '@/auth/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    fetchEvents(ctx, datas){
        return new Promise((resolve, reject) => {
            axiosIns.get('/event/list/',{params:{...datas, store_id:getUserData().store_id}})
            .then(response=>resolve(response))
            .catch(error=>reject(error))
        })
    },
    fetchEvent(ctx, id){
        return new Promise((resolve,reject) => {
            axiosIns.get('/event/'+id)
            .then(response=>resolve(response))
            .catch(error=>reject(error))
        })
    },
    addEvent(ctx,data){
        return new Promise((resolve, reject) => {
            axiosIns.post('/event', data,
            {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
            }
            )
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    deleteEvent(ctx,id){
        return new Promise((resolve, reject) => {
            axiosIns.delete('/event/'+id).then(response => resolve(response)).catch(error=>reject(error))
        })
    },
    updateEventTitle(ctx,data){
        return new Promise((resolve, reject) => {
            axiosIns.patch('/event/title',data).then(response => resolve(response)).catch(error=>reject(error))
        })
    },
    uploadEventImage(ctx, { event_id, formData }) {
        return new Promise((resolve, reject) => {
          axiosIns.post(`/event/${event_id}/images`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
      },
      fetchEventImages(ctx, event_id) {
        return new Promise((resolve, reject) => {
          axiosIns.get(`/event/${event_id}/images`)
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
      },
      deleteEventImage(ctx, { event_id, image_id }) {
        return new Promise((resolve, reject) => {
          axiosIns.delete(`/event/${event_id}/images/${image_id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
      },
  },
}
